module.exports = __webpack_public_path__ + "media/images/bg/shapes/cloud-2-b44ccc71484d4a9d711a394fb962a008.svg";